// Brainday voice: spell out zero through nine in body copy; 10+ stay as digits.
const SMALL_NUMBERS = [
  'zero',
  'one',
  'two',
  'three',
  'four',
  'five',
  'six',
  'seven',
  'eight',
  'nine',
] as const;

/** "one".."nine" for 0–9, the digit string for 10+ (and any non-small n). */
export const spellCount = (n: number): string => SMALL_NUMBERS[n] ?? String(n);
